<template>
    <v-row>
        <!-- Entrada -->
        <v-col>
            <v-toolbar
            color="secondary"
            class="rounded-lg"
            >  
                <v-toolbar-items>
                    <v-btn text class="white--text">
                        <b>Entrada</b>
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-btn text class="white--text">
                        {{ getValores()['entrada'] }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
        </v-col>

        <!-- Saida -->
        <v-col>
            <v-toolbar
            color="secondary"
            class="rounded-lg"
            >  
                <v-toolbar-items>
                    <v-btn text class="white--text">
                        <b>Saída</b>
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-btn text class="white--text">
                        {{ getValores()['saida'] }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
        </v-col>

        <!-- Saldo Atual -->
        <v-col>
            <v-toolbar
            color="secondary"
            class="rounded-lg"
            >  
                <v-toolbar-items>
                    <v-btn text class="white--text">
                        <b>Saldo (Atual)</b>
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-btn text class="white--text">
                        {{ getValores()['saldo_atual'] }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
        </v-col>

        <!-- Saldo Previsão -->
        <v-col>
            <v-toolbar
            color="secondary"
            class="rounded-lg"
            >  
                <v-toolbar-items>
                    <v-btn text class="white--text">
                        <b>Saldo (Previsão)</b>
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-btn text class="white--text">
                        {{ getValores()['saldo_previsao'] }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
        </v-col>
    </v-row>
</template>


<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: 'PainelValoresComp',

    methods: {
        ...mapActions(["painelValoresAction"]),
        
        ...mapGetters([
            "getValores",
            "getDateState",
            "getItemsEntrada",
            "getItemsSaida"
      ])
    },

    computed: {
        entrada() {
            return this.getItemsEntrada();
        },
        saida() {
            return this.getItemsSaida();
        }
    },

    mounted() {
        this.painelValoresAction(this.getDateState());
    },

    watch: {
        entrada: function () {
            this.painelValoresAction(this.getDateState());
        },
        saida: function () {
            this.painelValoresAction(this.getDateState());
        },
    },
}
</script>
